import { POLICY_TITLE, POLICY_EFFECTIVE_DATE, POLICY_TEXT } from "@/lib/legal";

// Renders the combined Terms + Privacy document. "1. HEADING" lines become
// section headings, "a. ..." lines become indented sub-points, the rest are
// paragraphs. Used by the one-time agreement gate and the "view anytime" dialog.
export const LegalContent = () => {
  const lines = POLICY_TEXT.split("\n").map((l) => l.trim()).filter(Boolean);
  return (
    <div className="space-y-3" data-testid="legal-content">
      <div className="mb-1">
        <h3 className="font-display text-base font-800 text-zinc-50">{POLICY_TITLE}</h3>
        <p className="mt-0.5 text-xs uppercase tracking-wide text-zinc-500">Last updated {POLICY_EFFECTIVE_DATE}</p>
      </div>
      {lines.map((line, i) => {
        if (/^\d+\.\s/.test(line)) {
          return <h4 key={i} className="pt-2 font-display text-sm font-800 tracking-tight text-zinc-100">{line}</h4>;
        }
        if (/^[a-z]\.\s/.test(line)) {
          return <p key={i} className="ml-4 text-sm leading-relaxed text-zinc-300">{line}</p>;
        }
        return <p key={i} className="text-sm leading-relaxed text-zinc-300">{line}</p>;
      })}
    </div>
  );
};
